import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Awards',
      type: 'table',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'sr.actions.delete-award',
            },
          },
          {
            '{}': {
              alias: 'sr.actions.save-award',
            },
          },
        ],
      },
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'awards',
                },
              },
              subqueries: {
                awards: {
                  target: 'ent:!awards:!award',
                },
              },
            },
          },
          query: {
            '`': {
              target: 'ent:!awards:!award',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      pi: {
                        '{}': {
                          value: {
                            '@': 'piNames',
                          },
                        },
                      },
                      fan: {
                        '{}': {
                          value: {
                            '@.': '!fan',
                          },
                          record: {
                            '{}': {
                              entityId: {
                                '@_': 'fan',
                              },
                              recordId: {
                                '@.': '!fan',
                              },
                            },
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                          record: {
                            '{}': {
                              entityId: {
                                '@_': 'code',
                              },
                              recordId: {
                                '@.': '!code',
                              },
                            },
                          },
                        },
                      },
                      fain: {
                        '{}': {
                          value: {
                            '@.': '!fain',
                          },
                          record: {
                            '{}': {
                              entityId: {
                                '@_': 'fain',
                              },
                              recordId: {
                                '@.': '!fain',
                              },
                            },
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                          record: {
                            '{}': {
                              entityId: {
                                '@_': 'name',
                              },
                              recordId: {
                                '@.': '!name',
                              },
                            },
                          },
                        },
                      },
                      budget: {
                        '{}': {
                          value: {
                            '@.': '!budget',
                          },
                          record: {
                            '{}': {
                              entityId: {
                                '@_': 'budget',
                              },
                              recordId: {
                                '@.': '!budget',
                              },
                            },
                          },
                        },
                      },
                      sponsor: {
                        '{}': {
                          value: {
                            '@': 'sponsorName',
                          },
                        },
                      },
                      award_date: {
                        '{}': {
                          value: {
                            '@.': '!award_date',
                          },
                          record: {
                            '{}': {
                              entityId: {
                                '@_': 'award_date',
                              },
                              recordId: {
                                '@.': '!award_date',
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  onEdit: {
                    '{}': {
                      action: {
                        '{}': {
                          payload: {
                            '{}': {
                              widget: {
                                '{}': {
                                  alias: 'sr.awards.widgets.edit-award',
                                },
                              },
                              variables: {
                                '{}': {
                                  awardId: {
                                    '@.': '!id',
                                  },
                                },
                              },
                            },
                          },
                          operation: 'ui.modal',
                        },
                      },
                    },
                  },
                  onClick: {
                    '{}': {
                      action: {
                        '{}': {
                          payload: {
                            '{}': {
                              goto: {
                                '{}': {
                                  variables: {
                                    '{}': {
                                      awardId: {
                                        '@.': '!id',
                                      },
                                    },
                                  },
                                  navigationId: 'award-details',
                                },
                              },
                            },
                          },
                          operation: 'ui.navigate',
                        },
                      },
                    },
                  },
                  onDelete: {
                    '{}': {
                      action: {
                        '{}': {
                          alias: 'sr.actions.delete-award',
                        },
                      },
                      confirm: {
                        '{}': {
                          title: 'Delete award',
                          message: 'Are you sure?',
                        },
                      },
                      variables: {
                        '{}': {
                          awardId: {
                            '@.': '!id',
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                awardPi: {
                  ref: {
                    attr: 'attr:ent#!award_pis#!entry:!award',
                  },
                  target: 'ent:!award_pis:!entry',
                },
                piNames: {
                  ref: {
                    attr: 'attr:ent#!award_pis#!entry:!pi',
                  },
                  using: 'awardPi',
                  target: 'ent:!personnel:!employee',
                  selection: {
                    '@.': '!name',
                  },
                },
                sponsorName: {
                  ref: {
                    attr: 'attr:ent#!awards#!award:!sponsor',
                  },
                  target: 'ent:!sponsors:!sponsor',
                  selection: {
                    '@.': '!name',
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!awards#!award:!code',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'name',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!awards#!award:!name',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'fan',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!awards#!award:!fan',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'fain',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!awards#!award:!fain',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'award_date',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!awards#!award:!award_date',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'budget',
                  dmsAttr: {
                    '{}': {
                      attributeId: 'attr:ent#!awards#!award:!budget',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'sponsor',
                  direct: {
                    '{}': {
                      name: 'Sponsor',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'pi',
                  dmsRef: {
                    '{}': {
                      source: 'attr:ent#!award_pis#!entry:!award',
                      target: 'attr:ent#!award_pis#!entry:!pi',
                    },
                  },
                },
              },
            ],
          },
          onCreate: {
            '{}': {
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias: 'sr.awards.widgets.edit-award',
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
        },
      },
    },
  },
}
